<!--内部组织-->
<template>
  <div class="cp_c_inorg">
    <div
      class="hideTree"
      title="收起树"
      @click="hideTree = !hideTree"
      :class="{'hide_tree_left':!hideTree , 'hide_tree_right':hideTree}"
    >
      <Icon type="ios-arrow-back" v-show="hideTree" />
      <Icon type="ios-arrow-forward" v-show="!hideTree" />
    </div>
    <div class="cp_c_left" :class="{'cp_c_left_show':hideTree , 'cp_c_left_hide':!hideTree}">
      <div class="search_tree">
        <Input icon="ios-search" v-model="query" />
      </div>
      <div class="cp_c_tree">
        <Tree :data="treeData" @on-select-change="clickTree" :query="query"></Tree>
      </div>
    </div>
    <div class="cp_c_right">
      <div class="cp_c_button">
        <Button type="error" @click="()=>{getTableData()}">查找</Button>
        <Button type="error" ghost @click="addOrder">新增</Button>
        <!-- <Button type="error" ghost @click="batchModify">批量修改</Button> -->
        <!-- <Button type="error" ghost>导入</Button> -->
        <!-- <Button type="error" ghost>导出</Button> -->
      </div>
      <div class="cp_c_form">
        <FormLayout :defaultColumn="defaultColumn" :defaultconfig="config"></FormLayout>
      </div>
      <div class="cp_c_table">
        <div class="pageStyle">
          <Page
            :total="page.total"
            :page-size="page.pageSize"
            :current="page.current"
            size="small"
            show-elevator
            show-sizer
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
          />
        </div>

        <Table
          :columns="tableData.columns"
          :data="tableData.data"
          @on-row-dblclick="onRowDblclick"
          @on-select="onSelect"
          @on-select-cancel="onSelectCancel"
          @on-select-all="onSelectAll"
          @on-select-all-cancel="onSelectAllCancel"
        ></Table>
      </div>
    </div>
    <!-- 批量修改按钮 -->
    <Modal v-model="modal.show" title="批量修改" @on-ok="ok" @on-cancel="cancel">
      <p>已选中批量修改记录数: {{onSelectData.length}}行</p>
      <Input />
    </Modal>
  </div>
</template>

<script>
//组织
import axios from 'axios'


export default {
  data() {
    return {
      modal: {
        show: false
      },
      onSelectData: [],
      hideTree: true,
      query: '',
      queryStyle: {
        background: 'red'
      },
      treeData: [],
      treeProcess: [],
      defaultColumn: 3,
      ids: [],
      page: {
        current: 1,  //当前页
        total: 0, //数据总数
        pageSize: 10,  //每页条数
      },
      formValue: {
        ECODE: '',
        ENAME: '',
        CP_C_ORGUP_ID: '',
        CP_C_STOREORG_ID: '',
      },
      config: [
        {
          item: {
            type: 'Input', // 组件类型
            required: true, // 是否必填
            label: '编码',
            props: {
              value: '',
            },
            event: {
              'on-change': (e) => {
                console.log(e);
                this.formValue.ECODE = e.target.value
              }
            }
          }
        },
        {
          item: {
            type: 'Input', // 组件类型
            required: true, // 是否必填
            label: '名称',
            props: {
              value: '',
            },
            event: {
              'on-change': (e) => {
                this.formValue.ENAME = e.target.value;
              }
            }
          }
        },
        {
          item: {
            type: 'DropDownSelectFilter',
            label: '上级组织',
            props: {
              data: {
                tabth: [],
                row: [],
                start: 0
              },
              totalRowCount: 10,
              pageSize: 5,
              dataEmptyMessage: '数据加载中...',
            },
            event: {
              'on-popper-show': () => {
                this.getSelData('group', 0, 5);
              },
              'on-page-change': (value) => {
                let self = this;
                let size = (value - 1) * 5;
                self.getSelData('group', size, 5);
              },
              'on-fkrp-selected': (value) => {
                console.log(value);
                this.formValue.CP_C_ORGUP_ID = [value[0].ID];
              },
              'on-clear': () => {
                this.formValue.CP_C_ORGUP_ID = '';
              }
            }
          }
        },
        // {
        //   item: {
        //     type: 'DropDownSelectFilter',
        //     label: '店仓销售区域',
        //     props: {
        //       data: {
        //         tabth: [],
        //         row: [],
        //       },
        //       totalRowCount: 10,
        //       pageSize: 5,
        //       dataEmptyMessage: '数据加载中...',
        //     },
        //     event: {
        //       'on-popper-show': () => {
        //         this.getSelData('store', 0, 5);
        //       },
        //       'on-page-change': (value) => {
        //         let self = this;
        //         let size = (value - 1) * 5;
        //         self.getSelData('store', size, 5);
        //       },
        //       'on-fkrp-selected': (value) => {
        //         console.log(value);
        //         this.formValue.CP_C_STOREORG_ID = [value[0].ID];
        //       },
        //       'on-clear': () => {
        //         this.formValue.CP_C_STOREORG_ID = '';
        //       }
        //     }
        //   }
        // }
      ],
      tableData: {
        columns: [
          {
            type: 'selection',
          },
          {
            title: '编码',
            key: 'ECODE'
          },
          {
            title: '名称',
            key: 'ENAME'
          },
          {
            title: '上级组织',
            key: 'CP_C_ORGUP_ID'
          },
          {
            title: '店仓销售区域',
            key: 'CP_C_STOREORG_ID'
          },
          {
            title: '是否分公司',
            key: 'ISCOM'
          },
          {
            title: '备注',
            key: 'REMARK'
          },
          {
            title: '修改人',
            key: 'MODIFIERENAME'
          },
          {
            title: '修改时间',
            key: 'MODIFIEDDATE'
          }
        ],
        data: []
      },
    }
  },

  methods: {
    //新增
    addOrder() {
      this.$store.commit("global/tabOpen", {
        type: 'tableDetailHorizontal',
        tableName: 'CP_C_INORG',
        tableId: 23236,
        id: 'New',
        dynamicRoutingForCustomizePage: true
      });
    },
    //选中树节点方法
    clickTree(value) {
      let self = this;
      console.log(value);
      self.ids = [];
      //获取数节点id
      self.getTreeID(value);
      console.log(self.ids);
      self.getTableData();
    },
    getTreeID(data) {
      let self = this;
      data.map(item => {
        self.ids.push(item.ID);
        if (item.children.length > 0) {
          self.getTreeID(item.children);
        }
      })
    },
    //获取树组织数据
    getTreeData() {
      let self = this;
      let formdata = new FormData();
      formdata.append('ORGTYPE', 'IN');
      self.$network.post('/p/cs/chrorgload', formdata).then(res => {
        if (res.data.code == 0) {
          self.treeProcess = JSON.parse(JSON.stringify(res.data.data));
          self.treeData = self.treeProcess.filter(item => item.CP_C_ORGUP_ID == null);
          self.treeData[0].title = self.treeData[0].MIXNAME;
          self.treeData.forEach(item => self.getTreeChildren(item));

          self.getTreeID(self.treeData);
          //初始化请求表格数据
          self.getTableData();
        } else {
          this.$Modal.fcError({
            title: '错误',
            content: res.statusText
          });
        }
      })
    },
    //获取每个子节点的方法
    getTreeChildren(pnode) {
      let self = this;

      pnode.children = this.treeProcess.filter(item => item.CP_C_ORGUP_ID === pnode.ID);
      pnode.children.forEach(item => {
        item.lastChild = false;
        item.title = item.MIXNAME;
        // item.expand = true;
        pnode.children[pnode.children.length - 1].lastChild = true;
        self.getTreeChildren(item);
      })
    },
    //获取表格数据
    getTableData() {
      let self = this;
      //获取数节点id
      let ids = `in (${self.ids.join(',')})`
      let current = (self.page.current - 1) * self.page.pageSize + 1;
      if (self.page.current == 1) {
        current = 0;
      }
      let obj = { table: "CP_C_INORG", column_include_uicontroller: true, fixedcolumns: self.formValue, multiple: [], startindex: current, rang: self.page.pageSize }
      if (self.ids.length > 0) {
        obj.reffixedcolumns = { ID: ids }
      }
      let formdata = new FormData();
      formdata.append('searchdata', JSON.stringify(obj));
      self.$network.post('/p/cs/QueryList', formdata).then(res => {
        if (res.data.code == 0) {
          let data = [];
          res.data.datas.row.map(item => {
            let objs = {};
            for (let key in item) {
              objs[key] = item[key].val
            }
            data.push(objs);
          })
          self.tableData.data = data;
          self.page.total = res.data.datas.totalRowCount;
        }
      })
    },
    //切换页码方法
    pageChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    //切换每页条数方法
    pageSizeChange(val) {
      this.page.pageSize = val;
    },
    //获取下拉单选组件数据方法
    getSelData(type, start = 0, range = 5) {
      let self = this;
      if (type == 'group' || type == 'two') {
        let formdata = new FormData();
        formdata.append('searchdata', JSON.stringify({ "isdroplistsearch": true, "refcolid": 130217, "startindex": start, "range": range }));
        self.$network.post('/p/cs/QueryList', formdata).then(res => {
          console.log(res);
          if (res.data.code == 0) {
            self.config[2].item.props.data.tabth = res.data.datas.tabth;
            self.config[2].item.props.data.row = res.data.datas.row;
            self.config[2].item.props.data.totalRowCount = res.data.datas.totalRowCount
          }
        })
      }

      if (type == 'store' || type == 'two') {
        let formdata1 = new FormData();
        formdata1.append('searchdata', JSON.stringify({ "isdroplistsearch": true, "refcolid": 152924, "startindex": start, "range": range }));
        self.$network.post('/p/cs/QueryList', formdata1).then(res => {
          console.log(res);
          if (res.data.code == 0) {
            self.config[3].item.props.data.tabth = res.data.datas.tabth;
            self.config[3].item.props.data.row = res.data.datas.row;
            self.config[3].item.props.data.totalRowCount = res.data.datas.totalRowCount
          }
        })
      }

    },
    //表格双击跳转
    onRowDblclick(val) {
      this.$store.commit("global/tabOpen", {
        type: 'tableDetailHorizontal',
        tableName: 'CP_C_INORG',
        tableId: 23236,
        id: val.ID,
      });
      let go2pageStr = `H.CP_C_INORG.23236.${val.ID}`
      let routeMapRecord = {}
      routeMapRecord[go2pageStr] = '/CUSTOMIZED/CP_C_INORG/2086'
      sessionStorage.setItem('routeMapRecord', JSON.stringify(routeMapRecord))
    },
    //批量修改按钮
    batchModify() {
      this.modal.show = true;
    },
    ok() {

    },
    cancel() {

    },
    onSelect(selection) {
      this.onSelectData = selection;
    },
    onSelectCancel(selection) {
      this.onSelectData = selection;
    },
    onSelectAll(selection) {
      this.onSelectData = selection;
    },
    onSelectAllCancel(selection) {
      console.log(selection);
      this.onSelectData = selection;
    },
  },

  mounted() {
    this.getTreeData();
    this.getSelData('two');
  },
}
</script>

<style lang="less">
.cp_c_inorg {
  height: 100%;
  display: flex;
  position: relative;
  padding-left: 15px;
  .hideTree {
    position: absolute;
    left: 225px;
    width: 15px;
    height: 100px;
    top: 50%;
    border: 0.5px solid #eae9e9;
    line-height: 100px;
    z-index: 99;
    cursor: pointer;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    transition: left 0.5s ease;
    border-right: 1px solid #d2d2d2;
  }
  .hideTree:hover {
    background: #f6f6f6;
  }
  .hide_tree_left {
    left: 0px;
  }
  .hide_tree_right {
    left: 225px;
  }
  .cp_c_left {
    height: 100%;
    width: 240px;
    overflow-y: auto;
    border-right: 1px solid #d2d2d2;
    .search_tree {
      margin-top: 8px;
      margin-bottom: 8px;
      margin-right: 5px;
    }
  }
  .cp_c_left_show {
    width: 225px;
    transition: width 0.5s ease;
  }
  .cp_c_left_hide {
    width: 0px;
    transition: width 0.5s ease;
  }

  .cp_c_right {
    flex: 1;
    margin-left: 5px;
    .cp_c_button {
      margin: 8px;
    }
    .cp_c_form {
      border: 1px solid #d8d8d8;
      padding: 8px;
      margin-bottom: 8px;
    }
    .cp_c_table {
      .pageStyle {
        margin: 8px 0;
      }
    }
  }
}
</style>